export default {
  Total: 'Today',
  Yesterday: 'Yesterday',
  Nearly7Day: 'Past 7 days',
  Export: 'Export',
  ControlDirection: 'Control Direction',
}